export const extractDeliveryRefNo = (deliveryRefNo) => {
  if (!deliveryRefNo) {
    return null
  }

  return deliveryRefNo.replace('<', '').replace('>', '').replace(/@.*/, '')
}
